import { Injectable } from '@angular/core';
import { BaseService } from '../../abstracts/base.service';
import { ConnectionModel } from '../../models/crm-model/connection.model';
import { ResultModel } from '../../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService extends BaseService {

  listAllForSelect(companyID: string = null) {
    if(companyID){
      return this.httpClient.get<ResultModel<ConnectionModel[]>>(this.getApiUrl(`connections?pCompanyID=${companyID}`));
    }
    else{
      return this.httpClient.get<ResultModel<ConnectionModel[]>>(this.getApiUrl('connections'));
    }
  }

  listAll(formData:FormData) {
    return this.httpClient.post<ResultModel<ConnectionModel[]>>(this.getApiUrl('connections/list'), formData);
  }

  create(connection: ConnectionModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('connections'), connection);
  }

  update(connection: ConnectionModel) {
    return this.httpClient.put(this.getApiUrl('connections'), connection);
  }

  get(id:string) {
    return this.httpClient.get<{ Connection: ConnectionModel }>(this.getApiUrl('connections/' + id));
  }

  delete(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('connections/' + id));
  }

}
